export const PUBLISHED = 'Published';
export const DRAFT = 'Draft';
export const CHANGED = 'Changed';
export const ARCHIVED = 'Archived';
